export const getSchoolUrl = (id, name, slug = null) => {
    // Use the slug if provided, otherwise fall back to generating from name
    const urlSlug = slug || name.replace(/[,\s]+/g, '-').toLowerCase();
    return `/campus/${id}-${urlSlug}`;
};
